import type { RootState } from '../../../store'

export const selectChargingSteeringState = (state: RootState) => state.chargingSteering
export const selectChargingSteeringVin = (state: RootState) => state.chargingSteering.vin
export const selectChargingSteeringPlanDraft = (state: RootState) =>
  state.chargingSteering.planDraft
export const selectChargingSteeringCalculationData = (state: RootState) =>
  state.chargingSteering.calculationData
export const selectChargingSteeringActionLoading = (state: RootState) =>
  state.chargingSteering.actionLoading
export const selectChargingSteeringCalculationLoading = (state: RootState) =>
  state.chargingSteering.calculationLoading
export const selectChargingSteeringTelemetryLoading = (state: RootState) =>
  state.chargingSteering.telemetryLoading
export const selectChargingSteeringExecuteLoading = (state: RootState) =>
  state.chargingSteering.executeLoading
export const selectChargingSteeringLastCommandMessage = (state: RootState) =>
  state.chargingSteering.lastCommandMessage
export const selectChargingSteeringLastExecutionId = (state: RootState) =>
  state.chargingSteering.lastExecutionId
export const selectChargingSteeringLastResponse = (state: RootState) =>
  state.chargingSteering.lastResponse
export const selectChargingSteeringError = (state: RootState) => state.chargingSteering.error
export const selectChargingSteeringTelemetryFrom = (state: RootState) =>
  state.chargingSteering.telemetryFrom
export const selectChargingSteeringTelemetryMessages = (state: RootState) =>
  state.chargingSteering.telemetryMessages
export const selectChargingSteeringTelemetryError = (state: RootState) =>
  state.chargingSteering.telemetryError
export const selectChargingSteeringFeedbackMessages = (state: RootState) =>
  state.chargingSteering.chargingFeedbackMessages
export const selectChargingSteeringFeedbackLoading = (state: RootState) =>
  state.chargingSteering.chargingFeedbackLoading
export const selectChargingSteeringFeedbackError = (state: RootState) =>
  state.chargingSteering.chargingFeedbackError
